import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Message } from 'semantic-ui-react';

import styles from './RebootSystem.module.scss';

const RebootSystem = React.memo(
  ({ canView, rebootSystemError, onRebootSystem, onClearMessage }) => {
    const [t] = useTranslation();

    return (
      canView && (
        <div className={styles.devicesWrapper}>
          <h2 className="page-title">{t('common.rebootSystem')}</h2>
          {rebootSystemError !== null && (
            <div className={styles.messageWrapper}>
              <Button
                type="button"
                icon="close"
                size="tiny"
                className={styles.closeMessage}
                onClick={() => onClearMessage(false)}
              />
              {rebootSystemError ? (
                <Message error header={t('common.rebootFailed')} />
              ) : (
                <Message success header={t('common.rebootSuccessed')} />
              )}
            </div>
          )}
          <p>{t('common.descriptionRebootSystem')}</p>
          <Button type="button" className={styles.buttonReboot} onClick={onRebootSystem}>
            {t('action.rebootSystem')}
          </Button>
        </div>
      )
    );
  },
);

RebootSystem.propTypes = {
  canView: PropTypes.bool.isRequired,
  rebootSystemError: PropTypes.bool,
  onRebootSystem: PropTypes.func.isRequired,
  onClearMessage: PropTypes.func.isRequired,
};

RebootSystem.defaultProps = {
  rebootSystemError: null,
};

export default RebootSystem;
